<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>微信机器人</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编号/id..."
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">
          新建
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:appId|string#or': searchValue,
                'regex:botId|string#or': searchValue,
                'regex:companyName|string#or': searchValue,
                'regex:companyId|string#or': searchValue,
                'regex:coordinatorName|string#or': searchValue,
                'regex:coordinatorPhone|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'wechatBot',
                title: '微信机器人'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.companyId" @click.native="unbind(scope.row)">
                    解绑
                  </el-dropdown-item>
                  <el-dropdown-item v-else @click.native="bindClick(scope.row)">
                    绑定
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == -1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="微信机器人"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="110px"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="微信机器人绑定企业"
      :visible.sync="openBindind"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="bindingFormData" ref="bindingFormData">
        <el-form-item label="机器人名称" prop="name">
          <el-input v-model="bindingFormData.name" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="绑定的企业"
          prop="orgId"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '请选择企业'
          }"
        >
          <el-cascader
            placeholder="可搜索企业名称"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            filterable
            clearable
            v-model="bindingFormData.orgId"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="企业联系人" prop="cname">
          <el-input v-model="bindingFormData.cname"></el-input>
        </el-form-item>
        <el-form-item label="企业联系人电话" prop="cphone">
          <el-input v-model="bindingFormData.cphone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="bind">确 定</el-button>
        <el-button @click="bindCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      name: 'wechatBot',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      openBindind: false,
      bindingFormData: {},
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        org: []
      },
      area: {
        options: this.osg.areaList
      }
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('wechatBot', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.getOrg();
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:appId|string#or': this.searchValue,
        'regex:botId|string#or': this.searchValue,
        'regex:companyName|string#or': this.searchValue,
        'regex:companyId|string#or': this.searchValue,
        'regex:coordinatorName|string#or': this.searchValue,
        'regex:coordinatorPhone|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/bot/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    bindClick(row) {
      this.bindingFormData = {
        name: row.name,
        botId: row.botId
      };
      this.openBindind = true;
    },
    bind() {
      if (this.osg.validate('bindingFormData')) {
        delete this.bindingFormData.name;
        this.osg.ajax('/biz/bot/bind.do', this.bindingFormData, () => {
          this.bindCancel();
          this.osg.toast('绑定成功');
          this.getData();
        });
      }
    },
    bindCancel() {
      this.openBindind = false;
      this.bindingFormData = {};
    },
    unbind(row) {
      this.osg.confirm(`是否确定解绑微信机器人“${row.name}”？`, () => {
        this.osg.ajax('/biz/bot/unbind.do', { botId: row.botId }, () => {
          this.osg.toast('解绑成功');
          this.getData();
        });
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax('biz/bot/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('biz/bot/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/bot/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除微信机器人“${row.name}”？`, () => {
        this.osg.ajax('biz/bot/delete.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功');
        });
      });
    },
    getOrg() {
      let params = {
        notFilterOrgId: '1',
        sortField: 'order'
      };
      this.osg.ajax('org/query.do', params, res => {
        var obj = res.data;
        obj.orgName = obj.orgName || '全部组织';
        this.options.orgs = [obj];
      });
    }
  }
};
</script>
